module.exports = __webpack_public_path__ + "img/全局美颜--可靠性.68545336.png";